import React from 'react';
import { Card, GroupLine, HorizontalLine, VerticalLine } from './Nodes.styles';
import { Avatar } from '../Avatar/Avatar';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Item } from '../../../../api/useEstatePlanningFlowQuery';
import { Separator } from '../../../../../../../../../../CommonComponents/OPL/Separator/Separator';
import { Shimmer } from '../../../../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

interface Props {
  items: Item[];
  isFirst?: boolean;
  isLast?: boolean;
}

export const NodesLoading = ({ items, isFirst, isLast }: Props) => {
  return (
    <>
      <HorizontalLine isFirst={isFirst} items={items.length}>
        <GroupLine isVisible={!isFirst && items.length > 1}>
          {items.map((_, itemIndex) => {
            return (
              <VerticalLine key={itemIndex} firstConnectorLine={isFirst} lastConnectorLine={isLast}>
                <Card py="12" px="16" color="neutral">
                  <Text textAlign="center">
                    <Avatar />
                  </Text>

                  <Shimmer width="90%" height={20} mx="auto" mt="8" />

                  <Separator my="8" />

                  <Shimmer width="50%" height={16} mx="auto" />

                  <Shimmer width="70%" height={20} mt="8" mx="auto" />
                </Card>
              </VerticalLine>
            );
          })}
        </GroupLine>
      </HorizontalLine>
    </>
  );
};
